import moment from "moment";

// Get visible note

export default (reports) => {
  return reports.sort((a, b) => {
    return a.createAt < b.createAt ? 1 : -1;
  });
};
